<template>
  <div v-for="error of props.errors" class="error-message" :key="error.$uid">
    {{ error.$message }}
  </div>
</template>

<script setup lang="ts">
import {ErrorObject} from "@vuelidate/core";

const props = defineProps<{
  errors: ErrorObject[];
}>();
</script>

<style scoped lang="scss">
.error-message {
  @apply text-xs text-red-500 mt-2;
}
</style>